import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { SEO } from '@/components/SEO';
import { Header } from '@/components/Header';

const NotFound = () => {
	const location = useLocation();

	useEffect(() => {
		console.error('404 Error: User attempted to access non-existent route:', location.pathname);
	}, [location.pathname]);

	return (
		<>
			<SEO
				title="404 - Page Not Found | CardSimp"
				description="The page you're looking for doesn't exist. Return to CardSimp's local card marketplace."
				noindex
			/>
			<div className="min-h-screen-safe flex flex-col bg-background">
				<Header />
				<main className="main-content-scroll flex flex-1 items-center justify-center overflow-auto">
					<div className="text-center">
						<h1 className="mb-4 text-4xl font-bold">404</h1>
						<p className="mb-4 text-xl text-muted-foreground/80">Oops! Page not found</p>
						<a href="/" className="text-primary underline hover:text-primary/80">
							Return to Home
						</a>
					</div>
				</main>
			</div>
		</>
	);
};

export default NotFound;
